import { allAbTests } from '@daymade/common-lib/abTests';
import { doABTestWithDistribution } from 'utils/analytics/abtest';
import { getTestGroupFromQueryOrStorage } from '../shared/getTestGroupFromQueryOrStorage';

type ChoicesForTest<T extends keyof typeof allAbTests> =
  (typeof allAbTests)[T][number]['choice'];
/** Returns the AB test group for the current browser state. This will:
 * - check the query string parameter for a test and testGroup, or any local storage, for a forced AB test group
 *   selection. If there is a forced group, no tracking will be sent
 * - check the local storage for a stored test and testGroup, and raise a tracking event. If no local storage exists
 *   for the testName, then a group will be picked based on the distribution.
 */
export function getABTestGroup<T extends keyof typeof allAbTests>(
  testName: T,
): ChoicesForTest<T> {
  const distribution: Array<{
    choice: ChoicesForTest<T>;
    weight: number;
    mobileOnly?: boolean;
  }> = allAbTests[testName];

  // Try to get the test group from the query or localStorage
  const testGroupFromQueryOrStorage = getTestGroupFromQueryOrStorage<
    ChoicesForTest<T>
  >(
    testName,
    distribution.map((x) => x.choice),
  );

  if (testGroupFromQueryOrStorage) {
    return testGroupFromQueryOrStorage;
  }

  // Fallback to A/B test logic if no test group is found
  const testGroup = doABTestWithDistribution(testName, distribution);

  return testGroup;
}
